(() => {
function buildContactMailto({offerRef='',offerName='',edition='',copy}) {
 const clean=(value,limit)=>String(value).replace(/[\x00-\x1f\x7f\u2028\u2029]/g,' ').trim().slice(0,limit);
 const ref=/^(L01|P01|S01|E0[12]|O01|RTW-[0-9]+)$/.test(offerRef)?offerRef:'';
 const name=ref?clean(offerName,96):'';
 const audience=clean(edition,48);
 const make=(label)=>{
  const subject=[copy.subject,audience,ref].filter(Boolean).join(' · ');
  const lines=[copy.greeting,'',copy.intent,`${copy.edition}: ${audience}`,`${copy.offer}: ${label || copy.unspecified}`,'',`${copy.name}: `,`${copy.phone}: `];
  if(ref.startsWith('RTW-')||!ref)lines.push(`${copy.size}: `);
  lines.push('',copy.closing);
  return 'mailto:customer@consiglieri.ro?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(lines.join('\r\n'));
 };
 const full=make(ref?[ref,name].filter(Boolean).join(' · '):'');
 if(full.length<=1500)return full;
 const short=make(ref);
 return short.length<=1500?short:'mailto:customer@consiglieri.ro?subject=The%20Black%20Voucher';
}

  let disposeContact;
  const initialize = () => {
    const root = document.getElementById('cs-ns');
    if (!root || root.dataset.initialized) return;
    if (disposeContact) disposeContact();
    root.dataset.initialized = 'true';
    const clock = window.CSNovemberClock?.get(root);
    if (!clock) return;
    const select = root.querySelector('select[name="offer"]');
    const sizeField = root.querySelector('.cn-size-field');
    const submit = root.querySelector('.cn-submit');
    const cards = Array.from(root.querySelectorAll('[data-rtw-category]'));
    const count = root.querySelector('.cn-rtw-count');
    let category = 'Toate';
    const updateRtw = () => {
      const matches = cards.filter(card => category === 'Toate' || card.dataset.rtwCategory === category);
      cards.forEach(card => { card.hidden = true; });
      matches.forEach(card => { card.hidden = false; });
      count.textContent = root.dataset.count.replace('{total}', String(matches.length));
    };
    root.querySelectorAll('.cn-filter').forEach(group => { group.hidden = false; });
    root.querySelectorAll('[data-filter]').forEach(button => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        root.querySelectorAll('[data-category]').forEach(card => { card.hidden = button.dataset.filter !== 'Toate' && card.dataset.category !== button.dataset.filter; });
      });
    });
    root.querySelectorAll('[data-rtw-filter]').forEach(button => {
      button.addEventListener('click', () => {
        category = button.dataset.rtwFilter;
        root.querySelectorAll('[data-rtw-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        updateRtw();
      });
    });
    updateRtw();
    if (!select) return;
    const contact = root.querySelector('[data-ns-contact]');
    let contactCopy;
    let syncContactWindow;
    if (contact) {
      try { contactCopy = JSON.parse(contact.querySelector('[data-contact-copy]').textContent); } catch (_) {}
      const link = contact.querySelector('[data-contact-link]');
      const banner = root.querySelector('[data-contact-banner]');
      const help = contact.querySelector('[data-contact-help]');
      const addressLabel = contact.querySelector('[data-contact-address-label]');
      const lifecycle = new AbortController();
      const listenerOptions = {signal:lifecycle.signal};
      let unsubscribe = () => {};
      disposeContact = () => { unsubscribe(); lifecycle.abort(); };
      syncContactWindow = () => {
        const current = clock.now();
        const open = !!contactCopy && (contact.dataset.preview === 'true' || clock.open());
        contact.dataset.allowed = String(open);
        if (open) {
          link.removeAttribute('aria-disabled'); link.removeAttribute('tabindex');
          link.textContent = contactCopy.cta;
          updateSelection();
        } else {
          link.removeAttribute('href'); link.setAttribute('aria-disabled','true'); link.setAttribute('tabindex','-1');
          link.textContent = current < 1793916000000 ? contact.dataset.preopen : contact.dataset.closed;
        }
        help.hidden = !open;
        addressLabel.textContent = (open ? contactCopy?.addressOpen : contactCopy?.addressOther) || addressLabel.textContent;
      };
      // Subscribe after updateSelection has been initialized below.
      contact._subscribeClock = () => { unsubscribe = clock.subscribe(syncContactWindow); };
      contact.addEventListener('click',event=>{
        if (!event.target.closest('[data-contact-link]')) return;
        syncContactWindow();
        if (contact.dataset.allowed !== 'true') event.preventDefault();
      },listenerOptions);
    }

    const updateSelection = () => {
      if (contact) {
        const option = select.selectedOptions[0];
        const current = contact.querySelector('[data-contact-current]');
        current.textContent = select.value ? option.textContent : '';
        const link = contact.querySelector('[data-contact-link]');
        if (link && contactCopy && contact.dataset.allowed === 'true') link.href = buildContactMailto({offerRef:select.value,offerName:option?.textContent || '',edition:contact.dataset.edition,copy:contactCopy});
        return;
      }

      const isRtw = select.value.startsWith('RTW-');
      sizeField.hidden = !isRtw;
      sizeField.querySelector('input').disabled = true;
      submit.textContent = isRtw ? root.dataset.requestRtw : root.dataset.requestCm;
    };
    select.addEventListener('change', updateSelection);
    root.querySelectorAll('[data-offer]').forEach(button => {
      button.addEventListener('click', () => {
        if (root.dataset.nsPhase !== 'open') return;
        select.value = button.dataset.offer;
        select.dispatchEvent(new Event('change', {bubbles:true}));
        root.querySelector('#cs-ns-request').scrollIntoView({block:'start'});
        select.focus({preventScroll:true});
      });
    });
    const requested = new URL(window.location.href).searchParams.get('voucher');
    if (requested && /^(L01|P01|S01|E01|E02|O01)$/.test(requested) && Array.from(select.options).some(option => option.value === requested)) {
      select.value = requested;
      select.dispatchEvent(new Event('change', {bubbles:true}));
    }
    updateRtw();
    updateSelection();
    if (syncContactWindow) contact._subscribeClock();
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
